export default "__VITE_ASSET__pNCnbyim__"